module.exports = __webpack_public_path__ + "static/media/case2.af226874.png";